module.exports = __webpack_public_path__ + "static/media/play.b342a4fe.svg";